<template>
  <div>
    <van-nav-bar :title="name"/>
    <div style="margin-top: -8px">
      <van-search
        v-model="keyword"
        shape="round"
        show-action
        @search="search"
        @clear="search"
        background="#FFF"
        clearable
        placeholder="请输入手机号/姓名" >
        <template #action>
          <div @click="showSearch">筛选</div>
        </template>
      </van-search>
    </div>
    <div class="workerBottom">
    <div class="huTotal">当前人数：{{total}}人</div>
    <div class="ht10"></div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="nextPage" :offset="300" :immediate-check="false">
      <div class="huperson card-1" v-for="item in list" :key="item.id">
        <div class="row1 fsb">
          <div class="fs">
            <div class="huname">{{item.name}}</div>
            <div :class="`huAuditStatus${item.auditStatus}`">{{audtiStatusMap[String(item.auditStatus)]}}</div>
            <div class="huAuditphone">{{item.phone}}</div>
          </div>
          <div style="margin-right: -11px">
          <van-tag 
            :color="auditResultMap[String(item.auditResult)][2]"
            :text-color="auditResultMap[String(item.auditResult)][1]">
            <div class="resultTag">
            {{auditResultMap[String(item.auditResult)][0]}}
            </div>
          </van-tag>
          </div>
        </div>
        <div class="ht10"></div>
        <div class="row2 fsb">
          身份证号：{{item.idCard}}
        </div>
        <div class="row2 fsb">
          居住地址：{{item.address}}
        </div>
        <div class="row2 fsb">
          <div>所属街道：{{item.streetOfficeName}}</div>
          <van-button round type="info" size="mini" color="#1F82FF" @click="goto(item)">
              <div class="syBtnTxtHome">详细信息</div>
            </van-button>
        </div>
        <van-divider></van-divider>
        <div class="row3 fsw">
          <div v-for="(k, i) in item.kz" :key="i" class="kzItem">{{k.slice(0, 5)}}</div>
        </div>
      </div>
    </van-list>
    <van-popup v-model="show" position="bottom" >
      <div class="tcc">
        <!-- {{helpUserType}} -->
        <!-- <div v-if="userType === 2">
          <div class="tcctitle">
            所属区域
          </div>
          <div class="fsw">
            <div class="tccOption one" :class="item.name === streetOffice ? 'active': ''" v-for="item in streetOfficeList" :key="item.name" @click="chooseStreeOffice(item)">
              {{item.name}}
            </div>
          </div>
          <div class="ht15"></div>
        </div> -->
        <div style="flex: 1">
          <div class="tcctitle">
            人员类别
          </div>
          <div class="fsw">
            <div class="tccOption two" :class="item.name === helpUserType ? 'active': ''" v-for="item in HelpTypeList" :key="item.name" @click="chooseHelpUserType(item)">
              {{item.name}}
            </div>
          </div>
          <div class="ht15"></div>
          <div class="tcctitle">
            是否年审
          </div>
          <div class="fsw">
            <div class="tccOption two" :class="k === auditStatus ? 'active': ''" v-for="(v, k) in audtiStatusMap" :key="k"  @click="chooseAuditStatus(k)">
              {{v}}
            </div>
          </div>
          <div class="ht15"></div>
          <div class="tcctitle">
            年审结果
          </div>
          <div class="fsw">
            <div class="tccOption two" :class="k === auditResult ? 'active': ''" v-for="(v, k) in auditResultMap" :key="k" @click="chooseAuditResult(k)">
              {{v[0]}}
            </div>
          </div>
        </div>
        <div class="ht15"></div>
        <div class="fsac">
        <van-button type="info" plain round style="width: 43vw" @click="reset">重置</van-button>
        <van-button type="info" round style="width: 43vw; margin-left: 10px" @click="search">确定</van-button>
        </div>
      </div>
    </van-popup>
      <van-tabbar v-model="active" @change="onChange" active-color="#1F82FF" inactive-color="#999999" placeholder>
        <van-tabbar-item>
          <template #icon>
            <img src="../../assets/home_active.png">
          </template>
          首页
        </van-tabbar-item>
        <van-tabbar-item icon="setting-o">
          <template #icon>
            <img src="../../assets/mine.png">
          </template>
          我的
        </van-tabbar-item>
      </van-tabbar>

    </div>
  </div>
</template>

<script>
  import { Toast, Button, Divider, NavBar, Tag, Search, Popup, List, Tabbar, TabbarItem } from 'vant'
  let _debounce = require('lodash/debounce')
  export default {
    components: {
      [Tabbar.name]: Tabbar,
      [TabbarItem.name]: TabbarItem,
      [Button.name]: Button,
      [Divider.name]: Divider,
      [NavBar.name]: NavBar,
      [Tag.name]: Tag,
      [Search.name]: Search,
      [Popup.name]: Popup,
      [List.name]: List
    },
    computed: {
      route () {
        return this.$route
      }
    },
    watch: {
      $route (to, from ) {
        // 监听路由变化, 实现类似 小程序的 onShow 事件
        if (to.path === '/my') {
          console.log(222)
          // do anything you want
        }
      }
    },
    
    async mounted() {
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e)) 
      // await this.getUserInfo()
      this.StreetOfficeGetList()
      this.HelpTypeGetList()
      this.nextPage()
      // this.HelpUserGetList()
    },
    data() {
      return {
        loading: false,
        finished: false,
        show: false,
        name: '',
        active: '',
        audtiStatusMap: {
          // '-1': '全部',
          '0': '未年审',
          '1': '已年审'
        },
        auditStatus: '-1',
        auditResultMap: {
          // '-1': '全部',
          '0': ['未年审', 'rgba(254,82,83, 1)', 'rgba(254,82,83, 0.15)'],
          '1': ['年审通过', 'rgba(31,130,255, 1)', 'rgba(31,130,255, 0.15)'],
          '2': ['年审失败', 'rgba(224,42,42, 1)', 'rgba(224,42,42, 0.15)'],
          '3': ['失联', 'rgba(242,133,26)', 'rgba(242,133,26, 0.15)']
        },
        auditResult: '-1',
        streetOfficeList: [],
        streetOffice: '',
        HelpTypeList: [],
        helpUserType: '',
        idCard: '',
        streetOfficeId: '1507239831007399936',
        keyword: '',
        resultList: [],
        list: [],
        total: 0,
        rows: 8,
        userType: 2,
        page: 0,
        helpTypeId: ''
      };
    },
    methods: {
      onChange(index) {
        if (index === 1) {
          this.$router.replace('/mine')
        }
      },
      goto ({id}) {
        // this.$router.push('index')
        this.$router.push({path: 'target', query: {userId: id, userType: this.userType}})
      },
      nextPage: _debounce(function (refresh = false) {
        this.page = this.page + 1
        this.getList(refresh)
      }, 100),
      showSearch () {
        this.show = true
      },
      reset () {
        this.helpTypeId = ''
        this.helpUserType = ''
        this.auditStatus = '-1'
        this.auditResult = '-1'
        this.search()
      },
      search () {
        this.show = false
        this.page = 0
        this.list = []
        this.nextPage()
      },
      chooseStreeOffice (target) {
        this.streetOffice = target.name
      },
      chooseHelpUserType (target) {
        this.helpUserType = target.name
        this.helpTypeId	= target.id
      },
      chooseAuditStatus (target) {
        this.auditStatus = target
      },
      chooseAuditResult (target) {
        this.auditResult = target
      },
      getType () {
        
      },
      showLoading(t = true) {
        Toast.loading({
          message: '请求中...',
          forbidClick: true,
          overlay: t,
          duration: 0
        })
      },
      async HelpTypeGetList () {
        let {success, info, data} = await this.$api.HelpTypeGetList()
        if (success) {
          this.HelpTypeList = data.rows
        } else {
          Toast.info(info)
        }
      },
      async StreetOfficeGetList () {
        let {success, info, data} = await this.$api.StreetOfficeGetList({page: 1, rows: 16})
        if (success) {
          this.streetOfficeList = data.rows
        } else {
          Toast.info(info)
        }
      },
      async getList(refresh = false) {
        if (this.page === 0 && !refresh) {
          console.log('!!!!!!!!!!!!')
          return
        }
        if (refresh) {
          this.list = []
        }
        let params = {
          streetOfficeId: this.streetOfficeId,
          page: this.page,
          rows: this.rows,
          auditStatus: this.auditStatus,
          auditResult: this.auditResult
          // sort: 'dInsertTime'
        }
        if (this.helpTypeId) {
          params.helpTypeId = this.helpTypeId
        }
        if (this.keyword) {
          params.keyword = this.keyword
        }
        this.showLoading()
        let { data, info, success } = await this.$api.HelpUserGetList(params)
        Toast.clear()
        this.loading = false
        if (success) {
          console.log(data.page, this.rows, data.total)
          if (data.page * this.rows >= data.total) {
            this.finished = true
          }
          for (let i = 0; i < data.rows.length; i++) {
            let t = data.rows.map(item => {
            item.kz = item.helpTypeName.split(',')
            return item
          })
            this.list.push(t[i])
          }
          this.total = data.total
          // this.loading = false
        } else {
          // this.loading = false
          this.finished = true
          Toast.fail(info)
        }
      },
      clear () {
        let key = `${this.idCard}-${this.name}`
        window.localStorage.removeItem(key)
        // window.location.reload()
        this.$router.replace('/login')
        Toast('已清空')
      },
      // goto(path) {
      //   if (this.isAudit) {
      //     Toast('您已通过年审')
      //   } else {
      //     this.$router.push(path)
      //   }
      // },
      replace(path) {
        this.$router.replace(path)
      }
    }
  }
</script>

<style>
  .fsw {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .syBtnTxt9{
    color: #1678ff;
    width: 74px;
    letter-spacing: 1px;
    font-size:14px
  }
  .workerUpsection {
    background: #fff;
  }
  .huTotal {
    color: #333;
    font-size: 12px;
    /* height: 16px;
    line-height: 16px; */
  }
  .workerBottom {
    margin: 10px;
  }
  .huperson {
    padding: 10px;
    border-radius: 6px;
    background: #fff;
    margin-bottom: 10px;
  }
  .row1 {
    height: 16px;
    line-height: 16px;
  }
  .huname {
    color: #333;
    font-weight: bold;
    font-size: 14px;
    width: 58px;
  }
  .huAuditStatus0 {
    font-size: 12px;
    color: #FE5252
  }
  .huAuditStatus1 {
    font-size: 12px;
    color: #13BB3A
  }
  .huAuditphone {
    color: #777;
    font-size: 12px;
    margin-left: 10px;
  }
  .row2 {
    /* height: 24px; */
    line-height: 24px;
    font-size: 12px;
    color: #555;
  }
  .row3 {
    line-height: 24px;
    font-size: 11px !important;
  }
  .kzItem {
    color:rgba(31,130,255, 0.82);
    font-size: 12px;
    margin-right: 8px;
    height: 24px;
  }
  .syBtnTxtHome {
    color: #fff;
    width: 74px;
    letter-spacing: 1px;
    font-size: 12px
  }
  .resultTag {
    font-size: 11px; 
    width: 46px; 
    text-align: center; 
    height: 20px; 
    line-height: 20px;
  }
  .tcc {
    display: flex;
    flex-direction: column;
    min-height: 65vh;
    /* width: 100vw; */
    background: #fff;
    padding: 10px;
    padding-right: 0px;
  }
  .tcctitle {
    height: 30px;
    line-height: 30px;
    color: #333;
    font-weight: bold;
    font-size: 13px
  }
  .tccOption {
    border: 1px solid #f8f8f8;
    border-radius: 2px;
    background: #f8f8f8;
    text-align: center;
    padding: 5px 10px;
    /* height: 30px;
    line-height: 30px; */
    font-size: 12px;
    color: #333;
    margin-right: 8px;
    margin-top: 8px
  }
  /* .tccOption.one {
    min-width: 79px;
  }
  .tccOption.two {
    min-width: 111px;
  } */
  .tccOption.active {
    background: #fff !important;
    color:rgba(31,130,255, 0.82) !important;
    border: 1px solid rgba(31,130,255, 0.82);
  }
</style>